import { render, staticRenderFns } from "./CommonAside.vue?vue&type=template&id=432d8dc9&scoped=true&"
import script from "./CommonAside.vue?vue&type=script&lang=js&"
export * from "./CommonAside.vue?vue&type=script&lang=js&"
import style0 from "./CommonAside.vue?vue&type=style&index=0&id=432d8dc9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432d8dc9",
  null
  
)

export default component.exports